<template>
    <div>
        <b-card class="card-accent-info" header="Financeiro - Reprocessar Saldo da Conta">
            <b-row>
                <b-col cols="auto">
                    <b-form-group>
                        <label for="user" style="font-size: 0.8em">Usuário</label>
                        <b-form-select id="user"
                            v-model="userId"
                            :plain="true"
                            :options="userDDL"                        
                            :value="[null,'c']">
                        </b-form-select>
                    </b-form-group>
                </b-col>

                <b-col cols="auto">
                  <b-form>
                    <b-form-group>
                        <label for="startDate" style="font-size: 0.8em">Data de Início</label>
                        <b-form-input v-model="startDate" type="date" id="startDate"></b-form-input>
                    </b-form-group>

                  </b-form>
                </b-col>

                <b-col cols="auto" class="mr-auto" style="padding-top: 12px;">
                    <b-form-group>
                        <p></p>
                        <b-button variant="stack-overflow" class="mr-1 btn-brand" @click="financeAccountMovementReprocess()"><i class="fa fa-search"></i><span>Reprocessar Saldo</span></b-button>
                    </b-form-group>
                </b-col>

            </b-row>
            Permite reprocessar o saldo dos usuários desde a data de início especificada.
            <p></p>
            <span class="text-muted">[GET] /finance/account/movement/reprocess?userId=<span class="text-danger">&lt;ID_USUARIO&gt;</span>&startRefDate=<span class="text-danger">&lt;DATA&gt;</span>&uid=<span class="text-danger">&lt;UID&gt;</span>&sid=<span class="text-danger">&lt;SID&gt;</span></span>           
        </b-card>
    </div>
</template>

<script>

import Vue from 'vue'
import axios from "axios";

/* Toast */
import VueNotifications from 'vue-notifications'
import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr

const toastTypes = {
    success: 'success',
    error: 'error',
    info: 'info',
    warn: 'warn'
}
  
miniToastr.init({types: toastTypes})
  
function toast ({title, message, type, timeout, cb}) {
    return miniToastr[type](message, title, timeout, cb)
}
  
const options = {
    success: toast,
    error: toast,
    info: toast,
    warn: toast
}
VueNotifications.setPluginOptions(options)
  
Vue.use(VueNotifications, options)
/* Toast - End */

export default {
    name: 'ActionFinanceAccountMovementReprocess',
    data: () => {
        return {
            userDDL: [],
            startDate: null,
            userId: 0
        }
    },
    methods: {
        async financeAccountMovementReprocess() {
            var s = this;
            var currentUser = this.$store.state.currentUser;
            var startDateDay = this.startDate.toString().replaceAll('-','')

            console.log(startDateDay)

            if(this.userId && this.userId > 0 && startDateDay.length == 8) {
                s.creatingPayment = true
                await axios.get(this.$store.state.ws_url + "/finance/account/movement/reprocess?userId=" + this.userId + "&startRefDate=" + startDateDay + "&uid=" + currentUser.id + "&sid=" + currentUser.sid

                ).then(function(resp) {
                    toast ({
                        type: VueNotifications.types.success,
                        title: 'Criar Movimentação',
                        message: 'Movimentação criada com sucesso.',
                        timeout: 2000
                    });

                    s.creatingPayment = false
                }).catch(function(error) {
                    toast ({
                        type: VueNotifications.types.error,
                        title: 'Criar Movimentação',
                        message: 'Erro ao criar movimentação',
                        timeout: 2000
                    });

                    s.creatingPayment = false
                })
            }
            else {
                toast ({
                    type: VueNotifications.types.error,
                    title: 'Reprocessar Saldo',
                    message: 'Selecione o usuário e a data de início',
                    timeout: 2000
                });
            }
        },

        async refreshUserList() {
            var s = this;
            var currentUser = this.$store.state.currentUser;
            await axios.get(
                this.$store.state.ws_url + "/user/ddl?companyId=" + currentUser.companyId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
            ).then(function(resp) {
                s.userDDL = resp.data.obj;                  
            })
            .catch(function(error) {
                console.log(error);
            });
            
        },
    },
    mounted: function() {
        var now = new Date()
        this.startDate = this.$utils.dateFormat(new Date(now.getFullYear(), now.getMonth(), 1))
        this.refreshUserList()
    }
}

</script>